<template>
  <div
    class="editorWrap"
    :class="[isEditFullScreen ? 'fullScreen' : '']"
    v-loading="uploading"
    element-loading-text="文件上传中">
    <div :id="editorId" ref="editor"></div>
    <HandleFinishedImg ref="handleFinishedImg" />
  </div>
</template>

<script>
// 富文本组件
import OSSClient from '../Uploads/OSS-client'
import HandleFinishedImg from "./HandleFinishedImg.vue";
import { imgUploadHelper } from "./helper";
import E from "wangeditor"
export default {
  components: {
    HandleFinishedImg
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    id: {
      type: String,
      default: '0'
    },
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请输入'
    },
    menus: {
      type: Array,
      default() {
        return []
      }
    },
    extraAttr: {
      type: Object,
      default() {
        return {
        }
      }
    },
    uploadImgFn: Function,
    limitImgSize: Number
  },
  data() {
    return {
      editor: null,
      clear_fullScreen_event: null,
      uploading: false,
      isEditFullScreen: false,
    }
  },
  computed: {
    editorId() {
      return `editor-${this.id}`
    }
  },
  methods: {
    // 校验图片尺寸
    validateImageDimensions(file) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
          const { limitWidth = [], limitHeight = [] } = this.extraAttr;
          const width = img.naturalWidth;
          const height = img.naturalHeight;
          
          // 校验宽度：0表示不校验该维度
          if (limitWidth[0] > 0 && width < limitWidth[0]) {
            reject(`宽度不能小于${limitWidth[0]}px`);
            return;
          }
          if (limitWidth[1] > 0 && width > limitWidth[1]) {
            reject(`宽度不能大于${limitWidth[1]}px`);
            return;
          }
          
          // 校验高度：0表示不校验该维度
          if (limitHeight[0] > 0 && height < limitHeight[0]) {
            reject(`高度不能小于${limitHeight[0]}px`);
            return;
          }
          if (limitHeight[1] > 0 && height > limitHeight[1]) {
            reject(`高度不能大于${limitHeight[1]}px`);
            return;
          }
          
          resolve({ width, height });
        };
        
        img.onerror = () => {
          reject('图片加载失败，请检查图片格式');
        };
        
        img.src = URL.createObjectURL(file);
      });
    },
    
    // 获取当前编辑器中的图片数量
    getCurrentImageCount() {
      const editorHtml = this.editor.txt.html();
      const div = document.createElement('div');
      div.innerHTML = editorHtml;
      return div.getElementsByTagName('img').length;
    },
    
    init_editor() {
      const { limitSize, limitNums, limitWidth = [], limitHeight = [] } = this.extraAttr;

      // this.editor = new E(`#${this.editorId}`)
      this.editor = new E(this.$refs.editor)

      this.editor.config.placeholder = this.placeholder;

      // 取消自动 focus
      this.editor.config.focus = false

      // 菜单配置
      this.editor.config.menus = this.menus.length ? this.menus : [
        'head',
        'bold',
        'fontSize',
        'fontName',
        'italic',
        'underline',
        'strikeThrough',
        'indent',
        'lineHeight',
        'foreColor',
        'backColor',
        'link',
        'list',
        // 'todo',   // 代办事项
        'justify',
        // 'quote',  // 引用
        // 'emoticon', // 表情
        'image',
        // 'video', // 视频
        'table',
        // 'code',  // 代码块
        // 'splitLine', // 分割线
        'undo',
        'redo',
      ]

      // 配置自定义上传图片 --- 上传至阿里oss
      this.editor.config.showLinkImg = false // 隐藏网络图片入口

      if(limitSize || this.limitImgSize) {
        this.editor.config.uploadImgMaxSize = limitSize || this.limitImgSize; // 限制图片大小 
      }
      // if(limitNums) {
      //   this.editor.config.uploadImgMaxNum = limitNums; // 限制图片数量
      // }
      // this.editor.config.customAlert = (info, a) => {
      //   this.$message.warning(info)
      // };

      this.editor.config.customUploadImg = async (resultFiles, insertImgFn) => {
        const currentImageCount = this.getCurrentImageCount();
        
        // 校验图片数量
        if (currentImageCount + resultFiles.length > limitNums) {
          return this.$message.error(`图片数量超限，最多可上传 ${limitNums} 张图片，当前已有 ${currentImageCount} 张`);
        }
        
        // 校验图片大小
        // const actualLimitSize = limitSize || this.limitImgSize;
        // if (actualLimitSize) {
        //   const maxSize = typeof actualLimitSize === 'string' ? eval(actualLimitSize) : actualLimitSize;
        //   const oversizeFiles = resultFiles.filter(item => item.size > maxSize);
        //   if (oversizeFiles.length > 0) {
        //     const maxSizeMB = Math.round(maxSize / (1024 * 1024));
        //     return this.$message.error(`图片大小超限，最大支持 ${maxSizeMB}MB`);
        //   }
        // }
        console.log('resultFiles', resultFiles)
        // 校验图片尺寸
        if(limitWidth[0] || limitWidth[1] || limitHeight[0] || limitHeight[1]) {
          try {
            const validationPromises = resultFiles.map(file => this.validateImageDimensions(file));
            await Promise.all(validationPromises);
          } catch (error) {
            return this.$message.error(error);
          }
        }
        
        this.uploading = true

        // 处理图片上传逻辑
        // success, fail 是调用上传接口后的相应回调，需要传入文件下标
        const [success, fail] = imgUploadHelper(resultFiles, (finishedImageArr) => {
          this.uploading = false
          this.$refs.handleFinishedImg.method_open(finishedImageArr, (imgs) => {
            this.editor.cmd.do("insertHtml", imgs.map(url => `<div style="text-align: center"><img src="${url}" /></div>`).join(''))
          })
        })

        resultFiles.forEach((file, index) => {
          if (this.uploadImgFn) {
            this.uploadImgFn(file, success(index), fail(index))
          } else {
            OSSClient.getInstance().singleUpload(`scm/${Date.now()}/${file.name}`, file, {
              success: success(index),
              fail: fail(index)
            })
          }
        });
      }

      // 配置自定义上传视频 --- 上传至阿里oss
      this.editor.config.showLinkVideo = false // 隐藏网络视频入口
      this.editor.config.customUploadVideo = (resultFiles, insertImgFn) => {
        resultFiles.forEach(file => {
          OSSClient.getInstance().singleUpload(`scm/${Date.now()}/${file.name}`, file, {
            success: (res) => {
              this.editor.cmd.do("insertHtml", `<div style="text-align: center"><video src="${res.url}" /></div>`)
            },
            fail: (err) => {
              console.log('fail---', err)
            }
          })
        });
      }

      // 文本改变时的回调
      this.editor.config.onchange = (html) => {
        if (this.isEmptyHtml(html)) {
          this.clear_text();
          this.$emit('change', '')
        } else {
          this.$emit('change', html)
        }
      }
      // 失去焦点时的回调
      this.editor.config.onblur = (html) => {
        if (this.isEmptyHtml(html)) {
          this.clear_text();
          this.$emit('change', '')
          this.$emit('blur', '')
        } else {
          this.$emit('change', html);
          this.$emit('blur', html)
        }
      }

      // 创建富文本控件
      this.editor.create()
      this.init_text()
      this.clear_fullScreen_event =  this.init_fullScreen_event()
    },
    isEmptyHtml(html) {
      if (!html) return false;
      let div = document.createElement('div')
      div.innerHTML = html
      let imgs = Array.from(div.getElementsByTagName('img'))
      return !imgs.length && !div.innerText
    } ,
    // 追加图片
    addImages(images) {
      this.editor.txt.append(images.map(url => `<div style="text-align: center"><img src="${url}" /></div>`).join(''))
    },
    // 创建时回填已有的数据
    init_text() {
      this.value && this.editor.txt.html(this.value)
    },
    // 清空富文本
    clear_text() {
      this.editor.txt.clear()
    },
    // 添加全屏及退出全屏的回调事件
    // 返回一个方法用于取消监听的事件
    init_fullScreen_event() {
      function getFullScreenStatus(target) {
        if (target.className === 'w-e-menu') {
          return target.dataset.title
        } else {
          return false
        }
      }
      const fullScreenEvent = (e) => {
        let fullScreenStatus = false 
        if (e.target.className === 'w-e-menu') {
          fullScreenStatus = getFullScreenStatus(e.target)
        } else {
          let parent = e.target.parentNode
          fullScreenStatus = getFullScreenStatus(parent)
        }
        if (fullScreenStatus) {
          this.isEditFullScreen = fullScreenStatus === '取消全屏'
          this.$emit('fullScreenChange', this.isEditFullScreen)
        }
      }
      this.editor.$toolbarElem.on('click', fullScreenEvent)
      return () => {
        this.editor.$toolbarElem.off('click', fullScreenEvent)
      }
    }
  },
  mounted() {
    OSSClient.getInstance()
    this.$nextTick(() => {
      this.init_editor()
    })
  },
  beforeDestroy() {
    this.clear_fullScreen_event && this.clear_fullScreen_event()
    this.editor && this.editor.destroy()
    this.editor = null
    this.uploading = false
    this.isEditFullScreen= false
  }
}
</script>

<style lang="scss" scoped>
.editorWrap {
  line-height: 0px;
  position: relative;
  & ::v-deep .el-loading-mask {
    z-index: 10000;
  }
  &.fullScreen {
    ::v-deep .el-loading-mask {
      z-index: 10002;
      position: fixed;
    }
  }
}
</style>